import axiosConfig from "./axiosConfig";
import { Lead } from "./getLeads";
import { SelectedOrg } from "./postLeadSearch";

// Per-row "as-displayed" selections the FE submits at promote
// time. The BE writes these onto the VOA entry verbatim - the FE
// is the source of truth for what gets promoted, which avoids the
// FE/BE drift class where the BE auto-picked defaults that didn't
// match what the operator saw on screen.
//
// All fields optional; missing keys leave the entry's column
// untouched. `null` is honoured: `selectedLandlord: null` means
// "no landlord", which is a valid promotion for a soft-signal
// lead. The operator can fill it in later via /leads.
export interface VoaPromoteSelection {
  selectedBuildingBkey?: string | null;
  selectedLandlord?: SelectedOrg | null;
  selectedTenant?: SelectedOrg | null;
  ownerOccupier?: boolean;
}

export interface VoaPromoteRequest {
  sourceRefs: string[];
  tags?: string[];
  // Keyed by VOA assessment ref. Optional for backward compat;
  // the FE always sends it today.
  selections?: Record<string, VoaPromoteSelection>;
}

export interface VoaPromoteSkip {
  sourceRef: string;
  reason: string;
}

export interface VoaPromoteResponse {
  created: Lead[];
  skipped: VoaPromoteSkip[];
}

const postVoaPromote = async (
  authToken: string,
  body: VoaPromoteRequest
): Promise<VoaPromoteResponse> => {
  const { data } = await axiosConfig.post(`/leads/voa-promote`, body, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default postVoaPromote;
